/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing a speech or presentation rehearsal against a target length.`)
};

const es_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar un discurso o el ensayo de una presentación contra una duración objetivo.`)
};

const de_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Rede oder Präsentationsprobe gegen eine Zielzeit stoppen.`)
};

const nl_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een speech of presentatierepetitie timen tegen een doellengte.`)
};

const fr_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer la répétition d’un discours ou d’une présentation par rapport à une durée cible.`)
};

const it_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare la prova di un discorso o di una presentazione rispetto a una durata obiettivo.`)
};

const pt_br2_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar o ensaio de um discurso ou apresentação em relação a uma duração alvo.`)
};

const pt_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar um discurso ou ensaio de apresentação em relação a uma duração alvo.`)
};

const ja_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標時間に対してスピーチやプレゼンテーションのリハーサルを計測する。`)
};

const zh_timer_stopwatch_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为演讲或演示彩排计时，对照目标时长。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_use3", locale)
	if (locale === "en") return en_timer_stopwatch_use3(inputs)
	if (locale === "es") return es_timer_stopwatch_use3(inputs)
	if (locale === "de") return de_timer_stopwatch_use3(inputs)
	if (locale === "nl") return nl_timer_stopwatch_use3(inputs)
	if (locale === "fr") return fr_timer_stopwatch_use3(inputs)
	if (locale === "it") return it_timer_stopwatch_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_use3(inputs)
	if (locale === "pt") return pt_timer_stopwatch_use3(inputs)
	if (locale === "ja") return ja_timer_stopwatch_use3(inputs)
	return zh_timer_stopwatch_use3(inputs)
};